export const environment = {
production: true,
baseApi: 'https://tg-empleos-api.tgconsulting.online/tg-empleo',
baseTG: 'https://tg-empleos.tgconsulting.online',
baseAssets: 'https://tg-empleos.tgconsulting.online/assets',
baseFrontEnd: 'https://tg-empleos.tgconsulting.online/front-end',
baseArchivos: 'https://uploads.tgconsulting.online/empleos/archivos/',
baseCursoImg: 'https://tg-site.tgconsulting.online/assets/banners/',
baseCurso: 'https://tg-site.tgconsulting.online/cursos/',
siteKey: '6LezkBYUAAAAALqK87d-g8Ev2IO_-DCiqzn6olUb',
pesoMaximoLogo: 100000, // 1 MB = 1000000 bytes
pesoMaximoPDF: 2000000, // 1 MB = 1000000 bytes
empresaDefault: '/assets/img/user/empresa-default.png',
candidatoDefault: '/assets/img/user/candidato-default.png',
// OAuth2 — reemplaza con tus credenciales reales
googleClientId: '1048713059114-36bbc550d903s73ookql07lm8v3rv1l3.apps.googleusercontent.com',
linkedinClientId: '78ahfqvru6ng0v',
linkedinRedirectUri: 'https://tg-empleos.tgconsulting.online/oauth/callback/linkedin',
};
